'use client';
import { useRef, useEffect, useMemo } from 'react';

/**
 * Преобразует функцию обратного вызова к ref,
 * чтобы избежать повторного рендеринга при передаче в качестве свойства
 * или избежать повторного выполнения эффектов при передаче в качестве зависимости.
 *
 * Отличие от useCallback - Позволяет не указывать массив зависимостей.
 */ var useCallbackRef = function(action) {
    var _callbackRef_current;
    var callbackRef = useRef(action);
    useEffect(function() {
        callbackRef.current = action;
    });
    return useMemo(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return callbackRef.current == null ? void 0 : (_callbackRef_current = callbackRef.current).call.apply(_callbackRef_current, [].concat([
                callbackRef
            ], args));
        };
    }, []);
};

export { useCallbackRef };
